function sort<T extends string | number>(a: T, b: T, order: 1 | -1 = 1): number {
  if (a < b) return -1 * order;
  if (a > b) return 1 * order;
  return 0;
}

export {
  sort
};
